import * as React from 'react'
import { StyledInput, colors } from '@components/shared'

export type PropsType = {
  isPromo?: boolean,
  isNameError: boolean
}

export type DispatchPropsType = {
  updateName: (name: string) => void
}
type StateType = {
  name?: string
}

export default class SubscriptionName extends React.PureComponent<PropsType & DispatchPropsType, StateType> {
  state: StateType = {
    name: ''
  }

  componentDidUpdate (prevProps: any, prevState: any): void {
    if (prevState.name !== this.state.name) {
      this.props.updateName(this.state.name || '')
    }
  }

  updateNameState = (e: any): void => {
    const name = e.target.value
    this.setState({
      name: name || ''
    })
  }

  render (): React.ReactNode {
    if (this.props.isPromo) {
      return (
        <StyledInput
          aria-label={'name on credit card'}
          id="cc-name ccname"
          name="cc-name ccname"
          autoComplete="cc-name ccname"
          type="text"
          required
          placeholder="Name on Card"
          value={this.state.name}
          onChange={this.updateNameState}
          color={'black'}
          style={{
            // keep here. stripe does not have access to our custom fonts
            background: 'white',
            textIndent: '20px',
            fontStyle: 'normal',
            fontFamily: 'sans-serif',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '16px',
            outline: 'none',
            height: '44px',
            paddingBottom: '1px',
            borderRadius: '7px',
            fontSmoothing: 'antialiased',
            marginBottom: '22px',
            boxSizing: 'border-box'
          }}
        />
      )
    }

    return (
      <StyledInput
        aria-label={'name on credit card'}
        id="cc-name ccname"
        name="cc-name ccname"
        autoComplete="cc-name ccname"
        required
        fontSize={'16px'}
        color={'black'}
        borderColor={colors.white}
        placeholder={'Name on Card'}
        value={this.state.name}
        onChange={this.updateNameState}
        isError={this.props.isNameError}
        background={colors.white}
        style={{ // keep here. stripe does not have access to our custom fonts
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '40px',
          marginBottom: '10px',
          fontFamily: 'Good Sans Regular, Roboto, Open Sans, Segoe UI, sans-serif',
          'background-color': colors.white
        }}
      />
    )
  }
}
